import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { AddUpdateSports } from "../../sub-modules";
import { CreateNewSport } from "../../utilities/api/sports/indext";
import { RuleType } from "../../utilities/types";
import { ToastContainer, toast } from "react-toastify";

const AddSports = () => {
    const navigate = useNavigate()
    const [ruleCount, setRuleCount] = useState(1);
    const [rules, setRules] = useState<RuleType[]>([{ subject: "", description: "" }])
    const [status, setStatus] = useState("true")
    const [sportName, setSportName] = useState("")
    const [image, setImage] = useState<any>()
    const [submitButton, setSubmitButton] = useState(false)

    const handleCreateUpdate = async (payload: any) => {
        setSubmitButton(true)
        const result = await CreateNewSport(payload)
        if (result.status === 200) {
            navigate("/sports")
        }
        else {
            toast.error(result.response.data.message);
        }
        setSubmitButton(false)
    }

    return (<>
        <AddUpdateSports submitButton={submitButton} sportName={sportName} setSportName={setSportName} name="Add Sport" status={status} setStatus={setStatus} rules={rules} setRules={setRules} ruleCount={ruleCount} setRuleCount={setRuleCount} handleCreateUpdate={handleCreateUpdate} setImage={setImage} image={image} />
        <ToastContainer />
    </>
    )
}
export { AddSports }